import React, { useEffect, useState } from 'react';
import { Modal, Table } from 'antd';
import type { ColumnsType, TablePaginationConfig } from 'antd/es/table';
import { viewPostLogs } from '../../api/adminAPI';
import type { UserData } from './config/columns/userColumns';

interface UserLogModalProps {
    open: boolean;
    user: UserData | null;
    onClose: () => void;
}

interface LogData {
    userName: string;
    postTitle: string;
    viewedAt: string;
}

const UserLogModal: React.FC<UserLogModalProps> = ({ open, user, onClose }) => {
    const [logs, setLogs] = useState<LogData[]>([]);
    const [loading, setLoading] = useState(false);
    const [total, setTotal] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);

    const fetchLogs = async (page: number, size: number) => {
        setLoading(true);
        try {
            const result = await viewPostLogs(
                undefined, 
                user?.username, 
                undefined, 
                undefined, 
                page,
                size
            );
            
            setLogs(result.content);
            setTotal(result.total);
        } catch (error) {
            console.error("조회 이력을 불러오는데 실패했습니다.", error);
        } finally {
            setLoading(false);
        }
    };

    const handleTableChange = (pagination: TablePaginationConfig) => {
        if (pagination.current && pagination.pageSize) {
            setCurrentPage(pagination.current);
            setPageSize(pagination.pageSize);
        }
    };

    useEffect(() => {
        if (open && user) {
            fetchLogs(currentPage, pageSize);
        } else {
            setLogs([]);
            setTotal(0);
            setCurrentPage(1);
            setPageSize(10);
        }
    }, [open, user, currentPage, pageSize]);

    const columns: ColumnsType<LogData> = [
        {
            title: '게시글 제목',
            dataIndex: 'postTitle',
            key: 'postTitle',
        },
        {
            title: '조회 일시',
            dataIndex: 'viewedAt',
            key: 'viewedAt',
            width: 180,
            align: 'center',
            render: (text: string) => {
                if (!text) return '-';
                return text.replace('T', ' '); 
            }
        }
    ];

    return (
        <Modal
            title={<span style={{ color: '#1890ff' }}>{user?.name}님의 조회 이력</span>}
            open={open}
            onCancel={onClose}
            footer={null}
            width={650}
            centered
        >
            <Table
                dataSource={logs}
                columns={columns}
                loading={loading}
                rowKey={(record, index) => `${record.postTitle}-${record.viewedAt}-${index}`}
                size="small"
                pagination={{
                    current: currentPage,
                    pageSize: pageSize,
                    total: total,
                    showSizeChanger: true,
                    pageSizeOptions: ['10', '20', '50'],
                    showTotal: (total) => `총 ${total}건`,
                }}
                onChange={handleTableChange}
            />
        </Modal>
    );
};

export default UserLogModal;